import React from 'react';
import { useTranslation } from 'react-i18next';
import { ColorChoice } from '@gift-variable-plugins/color-attribute-shared/ColorAttributeOptions';
import styles from './ColorAttributeDropdownItem.module.scss';

export const ColorAttributeDropdownItem = (choice: ColorChoice) => {
    const { t } = useTranslation();

    const previewStyle = choice.options?.assetUrl
        ? { backgroundImage: `url(${choice.options.assetUrl})`, backgroundSize: 'cover', backgroundPosition: 'center' }
        : { backgroundColor: choice.value };

    return (
        <>
            <div className={styles.preview} style={previewStyle} />
            {t(choice.label)}
        </>
    );
};